import debug from "debug";

const APP_NAME = "conference";

export default class Logger {
  constructor(prefix) {
    if (prefix) {
      this._debug = debug(`${APP_NAME}:${prefix}`);
      this._warn = debug(`${APP_NAME}:WARN:${prefix}`);
      this._error = debug(`${APP_NAME}:ERROR:${prefix}`);
      this._info = debug(`${APP_NAME}:INFO:${prefix}`);
    } else {
      this._debug = debug(APP_NAME);
      this._warn = debug(`${APP_NAME}:WARN`);
      this._error = debug(`${APP_NAME}:ERROR`);
      this._info = debug(`${APP_NAME}:INFO`);
    }

    /* eslint-disable no-console */
    this._debug.log = console.debug.bind(console);
    this._warn.log = console.warn.bind(console);
    this._error.log = console.error.bind(console);
    this._info.log = console.info.bind(console);
    /* eslint-enable no-console */
  }

  get debug() {
    return this._debug;
  }

  get warn() {
    return this._warn;
  }

  get error() {
    return this._error;
  }

  get info() {
    return this._info;
  }
}
